// 9 soru tipi için inline SVG iconlar — docs/design-ref/ HTML'den.

import type { QuestionType } from "@mahir/shared";

interface Props {
  type: QuestionType;
  size?: number;
}

export function QuestionTypeIcon({ type, size = 20 }: Props): JSX.Element {
  const common = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    width: size,
    height: size,
  } as const;

  switch (type) {
    case "text":
      return (
        <svg {...common}>
          <line x1="4" y1="9" x2="20" y2="9" />
          <line x1="4" y1="15" x2="14" y2="15" />
        </svg>
      );
    case "numeric":
      return (
        <svg {...common}>
          <text
            x="12"
            y="17"
            textAnchor="middle"
            fontSize="11"
            fontWeight="700"
            stroke="none"
            fill="currentColor"
          >
            123
          </text>
        </svg>
      );
    case "single":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="3.5" fill="currentColor" />
        </svg>
      );
    case "multi":
      return (
        <svg {...common}>
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <polyline points="8 12 11 15 16 9" />
        </svg>
      );
    case "date":
      return (
        <svg {...common}>
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      );
    case "file":
      return (
        <svg {...common}>
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
        </svg>
      );
    case "table":
      return (
        <svg {...common}>
          <rect x="3" y="3" width="18" height="18" rx="1" />
          <line x1="3" y1="9" x2="21" y2="9" />
          <line x1="3" y1="15" x2="21" y2="15" />
          <line x1="9" y1="3" x2="9" y2="21" />
          <line x1="15" y1="3" x2="15" y2="21" />
        </svg>
      );
    case "percent":
      return (
        <svg {...common}>
          <line x1="19" y1="5" x2="5" y2="19" />
          <circle cx="6.5" cy="6.5" r="2.5" />
          <circle cx="17.5" cy="17.5" r="2.5" />
        </svg>
      );
    case "repeater":
      return (
        <svg {...common}>
          <polyline points="17 1 21 5 17 9" />
          <path d="M3 11V9a4 4 0 0 1 4-4h14" />
          <polyline points="7 23 3 19 7 15" />
          <path d="M21 13v2a4 4 0 0 1-4 4H3" />
        </svg>
      );
    case "composite":
      // M15 — katmanlı kareler: birden fazla giriş alanını tek soruda birleştirir
      return (
        <svg {...common}>
          <rect x="3" y="3" width="12" height="12" rx="2" />
          <rect x="9" y="9" width="12" height="12" rx="2" />
        </svg>
      );
  }
}
